// Cart Toggle

const jsCartToggles = document.querySelectorAll(".js-toggle-cart-modal");

window.cartToggleListener = (e) => {
    e.preventDefault();
    e.target.closest(".js-toggle-cart-modal").classList.add("loading");
};

for (let i = jsCartToggles.length - 1; i >= 0; i--) {
    const toggle = jsCartToggles[i];
    toggle.addEventListener(
        "click",
        window.cartToggleListener
    );
}